import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

function AppLoader() {
  return (
    <div className="min-h-dvh bg-background flex items-center justify-center">
      <div className="pointer-events-none fixed inset-0 flex items-center justify-center">
        <div className="h-[600px] w-[600px] rounded-full bg-primary/15 blur-[120px]" />
      </div>
      <span className="relative z-10 text-2xl font-bold tracking-tight text-foreground/30 animate-pulse">
        Faro
      </span>
    </div>
  )
}

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isAdmin, loading } = useAuth()
  if (loading) return <AppLoader />
  if (!user || !isAdmin) return <Navigate to="/" replace />
  return <>{children}</>
}
